import { COUNTRY_BY_REGION_SUCCESS, SHOW__HIDE_LOADER, IS_ERROR, IS_UNAUTHORIZED } from '../constants/constants';

export function CommonReducer(state = {
    countryRegions: [],
    isError: false,
    isUnauthorized: false
}, action: any) {
    switch (action.type) {
        case COUNTRY_BY_REGION_SUCCESS:
            return {

                ...state,
                countryRegions: action.payload.data.payload
            }
        
        case SHOW__HIDE_LOADER:
            return {
                ...state,
                show: action.payload
            };
            case IS_ERROR:
            return {
                ...state,
                isError: action.payload
            }

            case IS_UNAUTHORIZED:
            return {
                ...state,
                isUnauthorized: action.payload
            }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer.common.tsx